import { CUSTOM_DATE_TIME_FORMAT, CUSTOM_TIME_FORMAT } from "constants"
import dayjs from "dayjs"

function buildGoogleMeetingSelectLabel(meeting) {
  const name = meeting?.meetingName?.trim() || ""
  const startRaw = meeting?.actualStartTime
  const endRaw = meeting?.actualEndTime
  if (!startRaw || !endRaw) return name
  const start = dayjs(startRaw)
  const end = dayjs(endRaw)
  const timeRange = start.isSame(end, "day")
    ? `${start.format(CUSTOM_DATE_TIME_FORMAT)} – ${end.format(CUSTOM_TIME_FORMAT)}`
    : `${start.format(CUSTOM_DATE_TIME_FORMAT)} – ${end.format(CUSTOM_DATE_TIME_FORMAT)}`
  return name ? `${name} (${timeRange})` : timeRange
}

function transformGoogleMeetingsEligibleResponse(resp) {
  const meetingsRaw = Array.isArray(resp?.meetings) ? resp.meetings : []
  return meetingsRaw?.map(meeting => ({
    ...meeting,
    label: buildGoogleMeetingSelectLabel(meeting),
  }))
}

export default transformGoogleMeetingsEligibleResponse
